// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/Rubik.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/Rubik-Italic.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
html,
body {
    height: 100%;
    margin: 0;
}


@font-face {
    font-family: 'Rubik';
    font-weight: bold;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
}

.font-preload.Rubik {
    font-family: 'Rubik', sans-serif;
}



@font-face {
    font-family: 'Rubik-Italic';
    font-weight: bold;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___})
}

.font-preload.Rubik-Italic {
    font-family: 'Rubik-Italic', sans-serif;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
